<template>
    <div>
        <!-- Heading -->
        <div class="d-flex flex-column flex-md-row align-items-md-center">
            <h1 class="mb-4">
                Saved Properties
            </h1>
        </div>
        <!-- END Heading -->

        <b-row class="mb-5">
            <b-col
                cols="12"
            >
                <p>Bookmark all your favourite properties for easy access.</p>
            </b-col>
        </b-row>

        <!-- Properties -->
        <b-row v-if="activeProperties.length">
            <!-- All properties -->
            <div
                v-for="property in activeProperties"
                :key="property.id"
                class="col-12 col-lg-6 mb-5"
            >
                <PropertyCard
                    :property="property"
                    :owned="false"
                    :icons="{ save: true, view: true }"
                />
            </div>
            <!-- END All properties -->
        </b-row>

        <b-row v-else>
            <b-col
                cols="12"
            >
                <p>You have no saved properties</p>
            </b-col>
        </b-row>
        <!-- END Properties -->
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PropertyCard from '../components/PropertyCard';

export default {
    name: 'SavedProperties',
    components: {
        PropertyCard
    },
    computed: {
        ...mapState('user', ['user']),
        activeProperties() {
            return this.user.bookmarks;
        }
    },
    mounted() {
        this.refreshUser();
    },
    methods: {
        ...mapActions('user', ['refreshUser'])
    }
};
</script>

<style lang="scss">

</style>
